module.exports = __webpack_public_path__ + "img/mw.317a10f4.svg";